var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLocationPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7453 0C13.4974 0 6 7.45103 6 16.6436C6 19.9572 6.98322 23.0459 8.65583 25.6395L22.7453 45L36.8359 25.6407C38.6543 23.143 39.4918 19.956 39.4918 16.6447C39.4906 7.4499 31.9944 0 22.7453 0Z",
    fill: "#509BC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7467 9.24683C26.8559 9.24683 30.1887 12.5593 30.1887 16.6436C30.1887 20.7279 26.8547 24.0415 22.7467 24.0415C18.6375 24.0415 15.3047 20.7279 15.3047 16.6436C15.3047 12.5593 18.6386 9.24683 22.7467 9.24683Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocationPointer);
export default __webpack_public_path__ + "static/media/ic-location-pointer.4bb62a29639050a33bef4f63af318192.svg";
export { ForwardRef as ReactComponent };